import React from 'react';
import Slider from 'react-slick';
import properties from '../../../modules/ajio-util/properties';
import { replaceWithJioCDN } from '../../../../src/utils/imageHandling';
/**
 *
 * @param {*} props
 *
 * Click tracker for slider
 */
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  const isDisabled = className?.includes('slick-disabled');
  const display = props.slideCount <= 5 ? 'none' : 'block';
  return (
     <div
      className={className}
      style={{ display, textAlign: 'center', ...style }}
      role="button"
      onClick={isDisabled ? undefined : onClick}
      aria-label="Scroll down"
      aria-disabled={isDisabled ? 'true' : 'false'}
      tabIndex={isDisabled ? -1 : 0}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !isDisabled) {
          e.preventDefault();
          e.currentTarget.click();
        }
      }}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  const isDisabled = className?.includes('slick-disabled');
  const display = props.slideCount <= 5 ? 'none' : 'block';

  return (
    <div
      className={className}
      style={{ display, textAlign: 'center', ...style }}
      role="button"
      onClick={isDisabled ? undefined : onClick}
      aria-label="Scroll up"
      aria-disabled={isDisabled ? 'true' : 'false'}
      tabIndex={isDisabled ? -1 : 0}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !isDisabled) {
          e.preventDefault();
          e.currentTarget.click();
        }
      }}
    />
  );
}

class ImgView extends React.Component {
  constructor(props) {
    super(props);
    this.tablistRef = React.createRef();
    this.tabRefs = [];
    this.tabCount = 0;
    this.arrowRefs = []
    this.isMouseDown = false 
    this.observer = null;
    this.elementRef = null;
  }

  handleTabFocus = () => {
    if (this.isMouseDown) {
      return;
    }
    if (this.props.updateIsPlay)
      this.props.updateIsPlay(false)
  };

  handleTabBlur = () => {
    if (this.isMouseDown) {
      return;
    }
    if (this.props.updateIsPlay)
      this.props.updateIsPlay(true)
  };

  handleTabClickOnPrev = (e) => {
    let count = this.slider.props.slideCount;
    if(count <= 5) return
    if (e.key === 'Tab' && !e.shiftKey) {
      if (this.tabRefs.length) {
        e.preventDefault();
        this.tabRefs[this.props.selectedImageId]?.focus();
      }
    }
  }

  handleTabClickOnNext = (e) => {
    let count = this.slider.props.slideCount;
    if(count <= 5) return
    if (e.key === 'Tab' && e.shiftKey) {
      if (this.tabRefs.length) {
        e.preventDefault();
        this.tabRefs[this.props.selectedImageId]?.focus();
      }
    }
  }

  handleMouseClickInsideTabpanel = () => {
    this.isMouseDown = true;
    setTimeout(() => {
      this.isMouseDown = false;
    }, 0); // Reset after click handling
  }

  componentDidMount() {
    const arrows = document.querySelectorAll('.slick-arrow');
    const prevArrow = arrows[0];
    const nextArrow = arrows[1];
    this.arrowRefs = arrows

    // 1. Add event listener for Tab key on first arrow
    if (prevArrow)
      prevArrow.addEventListener('keydown', this.handleTabClickOnPrev);

    // 2. Add event listener for Shift+Tab on second arrow
    if (nextArrow)
      nextArrow.addEventListener('keydown', this.handleTabClickOnNext);

    if (this.tablistRef.current) {
      this.tablistRef.current.addEventListener('mousedown', this.handleMouseClickInsideTabpanel);
      this.tablistRef.current.addEventListener('focusin', this.handleTabFocus);
      this.tablistRef.current.addEventListener('focusout', this.handleTabBlur);
    }
  }

  componentWillUnmount() {
    this.arrowRefs[0]?.removeEventListener('keydown', this.handleTabClickOnPrev);
    this.arrowRefs[1]?.removeEventListener('keydown', this.handleTabClickOnNext);

    if (this.tablistRef.current) {
      this.tablistRef.current.removeEventListener('mousedown', this.handleMouseClickInsideTabpanel);
      this.tablistRef.current.removeEventListener('focusin', this.handleTabFocus);
      this.tablistRef.current.removeEventListener('focusout', this.handleTabBlur);
    }
        if (this.observer) {
      this.observer.disconnect();
    }
  }

  handleError(event) {
    event.target.src = `${properties.getProperty('imageBaseUrl')}/static/img/plp.png`;
  }

  componentWillReceiveProps(nextProps) {
    try {
      if (nextProps.isPlay) {
        let count = this.slider.props.slideCount;
        let currentId = this.props.selectedImageId || 0;
        let nextId = nextProps.selectedImageId;
        if (count > 5) {
          if (currentId == count - 1) {
            this.slider.slickGoTo(0);
          } else if (nextId < currentId) {
            this.slider.slickPrev();
          } else {
            this.slider.slickNext();
          }
        }
      } else {
        this.slider.innerSlider.pause();
      }
    } catch (error) {
      console.log(error)
    }
  }

  handleTabKeyDown = (event, index) => {
  try{
    let flag = false;

    const tabCount = this.tabCount
    switch (event.key) {
      case 'ArrowDown':
        this.setSelectedTab((index + 1) % tabCount);
        flag = true;
        break;

      case 'ArrowUp':
        this.setSelectedTab((index - 1 + tabCount) % tabCount);
        flag = true;
        break;

      case 'Home':
        this.setSelectedTab(0);
        flag = true;
        break;

      case 'End':
        this.setSelectedTab(tabCount - 1);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      if (this.props.updateTabControl)
 {       this.props.updateTabControl(true)
      event.stopPropagation();
      event.preventDefault();}
    } else {
      if (this.props.updateTabControl)
      this.props.updateTabControl(false)
    }
  } catch (error) {
    console.log(error)
  }
  };


  setSelectedTab = (index) => {
    try {
      if (index === this.props.selectedImageId) {
        return;
      }
      if (this.tabRefs[index]) {
        this.tabRefs[index].focus();
      }
      if (this.props.onSelect) {
        this.props.onSelect(index);
      }

    } catch (error) {
      console.log(error)
    }
  };

  render() {
    const prodData = this.props.imgdata;
    let selectedImageId = this.props.selectedImageId || 0;
    let onSelect = this.props.onSelect;
    const { isPlay = true, isTabPanelArrowControl = false } = this.props;
    let slickSettings = {
      dots: false,
      vertical: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: false,
      autoplay: false,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };

    const filterByImgType = image => {
      if (image.format === 'thumbnail' && image.imageType !== 'PRIMARY') {
        return true;
      }
    };
    const { images = [] } = prodData;
    let filteredImgList = images.filter(filterByImgType);
    this.tabCount = filteredImgList.length;
    let addClass = 'mt-50';
    if (filteredImgList.length > 5) {
      addClass = 'mt-25';
    }
    if (filteredImgList.length < 5) {
      slickSettings = {
        dots: false,
        vertical: true,
        slidesToShow: filteredImgList.length,
        slidesToScroll: 1,
        infinite: false,
        autoplay: false,
        arrows: false
      };
    }
    const { brandName = '', name = '' } = prodData;
    let imageList = filteredImgList.map((image, i) => {
      return (
        <div key={i}
          id={`carousel-tab-${i + 1}`}
          type="button"
          role="tab"
          aria-label={`Slide ${i + 1}`}
          aria-selected={selectedImageId === i ? true : false}
          aria-controls={`carousel-item-${i + 1}`}
          ref={(el) => {
            this.tabRefs[i] = el
          

            // focus fix
            // we are using this mutation observer appraoch because the slider library used here keeps overwriting our tabindex so focus on image tabs is very inconsistent
            // Cleanup when ref is removed (e.g., unmount or re-render)
            if (!el) {
              if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
              }
              this.elementRef = null;
              return;
            }

            this.elementRef = el;

            // Initial check
             const isSelected = el.getAttribute("aria-selected") === "true";
    el.tabIndex = isSelected ? 0 : -1;

            // Create MutationObserver
            this.observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (
                  mutation.type === "attributes" &&
                  mutation.attributeName === "aria-selected"
                ) {
                   const isSelected = el.getAttribute("aria-selected") === "true";
    el.tabIndex = isSelected ? 0 : -1;
                }
              });
            });

            // Observe aria-selected attribute
            this.observer.observe(el, {
              attributes: true,
      attributeFilter: ["aria-selected"],
    });
            
          }}
          onKeyDown={(e) => this.handleTabKeyDown(e, i)}
          tabIndex={selectedImageId === i ? 0 : -1}
          onClick={() => onSelect(i)}
        >
          <div className="img-container"  >
            <img
              className={selectedImageId === i ? 'img-highlight img-alignment' : 'img-alignment'}
              src={`${replaceWithJioCDN(image.url)}`}
              alt={`Product image of ${brandName} ${name}`}
              onError={this.handleError}
            />
          </div>
        </div>
      );
    });

    return (
      <div className={`product-image-gallery ${addClass}`}>
        <div className="prod-video" aria-hidden="true" />
        {imageList?.length > 0 && (
          <div role="tablist" aria-label="Slides" ref={this.tablistRef}>
          <Slider
            ref={c => (this.slider = c)}
            {...slickSettings}
            slideCount={filteredImgList.length}
          >
            {imageList}
          </Slider>
          </div>
        )}
      </div>
    );
  }
}

export default ImgView;
